import SellerUtils from 'utils/SellerUtils';
import { GET, GET_ALL, isValid } from './Clients';

const SUPPLIER_API_PREFIX = '/seller/core/v1';

export async function getInfoSupplier({ ctx, slug }) {
  return GET({
    ctx,
    url: `${SUPPLIER_API_PREFIX}/seller/info`,
    isBasic: true,
    params: {
      q: slug || null,
    },
  });
}

// for api/seller/index.js
// nhằm hạn chế data trả ra ngoài nên sẽ làm api/seller để lấy hết data , rồi trả ra 1 api dạng internal
async function getAll({ ctx, sellerCodes = [], search }) {
  return GET_ALL({
    ctx,
    url: `${SUPPLIER_API_PREFIX}/account/list`,
    isBasic: true,
    isAuth: false,
    params: {
      getStoreInfo: true,
      sellerCodes,
      search,
      limit: sellerCodes.length ? sellerCodes.length : 20,
    },
  });
}

async function getSellerConfig({ ctx, sellerCodes }) {
  return GET({
    ctx,
    url: `${SUPPLIER_API_PREFIX}/seller/config`,
    params: { sellerCodes },
  });
}

// for web
async function getSellersV2(sellerCodes = []) {
  return GET({
    url: `${SUPPLIER_API_PREFIX}/seller/code`,
    params: {
      sellerCodes: [...new Set(sellerCodes)],
      getStoreInfo: true,
    },
    isBasic: true,
  }).then((res) => {
    if (isValid(res)) {
      res.data = res.data.map(SellerUtils.convertSeller);
    }
    return res;
  });
}

export async function getSellersByCodes(sellerCodes = []) {
  return GET({
    url: `${SUPPLIER_API_PREFIX}/seller/code`,
    params: {
      sellerCodes,
      getStoreInfo: true,
    },
    isBasic: true,
    isAuth: false,
  }).then((res) => {
    if (isValid(res)) {
      res.data = res.data.map(SellerUtils.convertSeller);
    }
    return res;
  });
}

// for web certificate page — license documents sourced live from the IAM entity
// (PDF only, identity images stripped by BE). Returns a map keyed by license type.
async function getSellerCertificates(sellerCode) {
  return GET({
    url: `${SUPPLIER_API_PREFIX}/seller/certificate`,
    params: { sellerCode },
    isBasic: true,
  });
}

async function searchSellersV2(search = '') {
  return GET({
    url: `${SUPPLIER_API_PREFIX}/account/list`,
    params: {
      search,
      getStoreInfo: true,
    },
  }).then((res) => {
    if (isValid(res)) {
      res.data = res.data.map(SellerUtils.convertSeller);
    }
    return res;
  });
}

export default {
  getInfoSupplier,
  getAll,
  getSellerConfig,
  getSellersV2,
  getSellerCertificates,
  searchSellersV2,
};
